import React from 'react';
import styled from 'styled-components';
import solanaLogo from '../assets/solana-sol-logo.svg';
import dexLogo from '../assets/dexscreener.svg';
import dextoolsLogo from '../assets/dextools.svg';
import devImage from '../assets/dev.png';

const About = styled.section`
  padding: 4rem 2rem;
  background: #fff;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-family: 'Raleway', sans-serif;
`;

const Subtitle = styled.p`
  font-size: 1.4rem;
  margin: 0 auto;
  max-width: 1000px;
  font-family: 'Raleway', sans-serif;
  color: #333;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: left;
  font-family: 'Raleway', sans-serif;
`;

const Image = styled.img`
  width: 100%;
  border-radius: 10px;
`;

const AboutSection = () => {
  return (
    <About id="about">
      <Title>About AdChain</Title>
      <Subtitle>
        AdChain is a decentralized advertising platform that connects advertisers and publishers directly, ensuring transparency and efficiency using Solana's blockchain technology. Say goodbye to intermediaries and hello to direct, real-time transactions.
      </Subtitle>

      <Image src={solanaLogo} alt="Solana Logo" style={{ width: '150px', height: 'auto', margin: '3rem 4rem' }} />
      <Image src={dexLogo} alt="DexScreener Logo" style={{ width: '200px', height: 'auto', margin: '0rem 4rem' }} />
      <Image src={dextoolsLogo} alt="DexTools Logo" style={{ width: '200px', height: 'auto', margin: '0rem 4rem', marginBottom: '20px' }} />

      <Content>
        <h3>What is AdChain?</h3>
        <p>
          AdChain is a groundbreaking platform designed to revolutionize the digital advertising industry by leveraging the power of blockchain technology. Our mission is to create a transparent, efficient, and secure environment where advertisers and publishers can interact directly, eliminating the need for intermediaries. This approach reduces costs, increases transparency, and provides real-time reporting and fraud prevention.
        </p>

        <h3>How AdChain Works</h3>
        <p>
          AdChain leverages the Solana blockchain to facilitate secure and transparent transactions between advertisers and publishers. By using blockchain technology, AdChain ensures that all transactions are immutable and verifiable, providing an unprecedented level of trust and security in the advertising industry.
        </p>
        <p>
          Advertisers can create campaigns and set budgets using AdToken (ADT), the native utility token of the AdChain platform. Publishers, in turn, can participate in these campaigns by displaying ads on their platforms and earning ADT as compensation.
        </p>
        <p>
          The entire process is automated through smart contracts, which handle the distribution of funds, tracking of ad performance, and enforcement of campaign terms. This automation reduces the need for intermediaries and minimizes the risk of fraud.
        </p>

        <h3>Key Features</h3>
        <ul>
          <li>Decentralized platform for direct interaction between advertisers and publishers.</li>
          <li>Utilizes Solana's blockchain for secure and efficient transactions.</li>
          <li>Real-time transparency and reporting.</li>
          <li>Eliminates fraud and reduces costs.</li>
          <li>Automated smart contracts for managing ad campaigns.</li>
          <li>Tokenized incentives for participation and engagement.</li>
        </ul>

        <h3>Tokenomics</h3>
        <p>
          The AdChain ecosystem is powered by the AdToken (ADT). AdToken is the utility token used for all transactions within the AdChain platform. AdChain will be listed on pump.fun, ensuring a community-driven approach with a market cap of $1M. Here are the key aspects of AdToken's tokenomics:
        </p>
        <ul>
          <li><strong>Ticker:</strong> ADT</li>
          <li><strong>Total Supply:</strong> 1,000,000,000 ADT</li>
          <li><strong>Distribution:</strong></li>
          <ul>
            <li>100% - Community Driven</li>
            <li>Market Cap: $1M</li>
          </ul>
        </ul>

        <h3>About the Developer</h3>
        <div style={{ justifyContent: 'center', display: 'flex'}}>
          <Image src={devImage} alt="Akmal Aitmatov" style={{ width: '200px', height: 'auto', margin: '2rem 0rem', marginBottom: '20px', alignSelf: 'center' }} />
        </div>
        <p>
          AdChain was developed by Akmal Aitmatov, a proficient software developer from Central Asia. Akmal studied computer science at Tallinn University of Technology in Estonia. With a strong passion for blockchain technology and decentralized systems, he has dedicated his career to creating innovative solutions that empower users and enhance transparency in digital transactions.
        </p>
      </Content>
    </About>
  );
};

export default AboutSection;
